import { useMemo } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import type { DailyScorePoint } from '../../../api/generated';
import { chartColors } from './chartColors';

interface UsageChartProps {
  data: DailyScorePoint[];
}

export function UsageChart({ data }: UsageChartProps) {
  const chartData = useMemo(
    () =>
      data
        // Only plot days that actually have a score, so the line focuses on the
        // active range instead of trailing across weeks of empty grid.
        .filter((d) => d.avg_score != null)
        .map((d) => ({
          date: d.date.slice(5), // "MM-DD"
          score: d.avg_score,
          count: d.count,
        })),
    [data]
  );

  if (chartData.length === 0) {
    return null;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" fontSize={12} />
        <YAxis domain={[0, 100]} fontSize={12} />
        <Tooltip
          formatter={(value) =>
            typeof value === 'number' ? value.toFixed(1) : 'N/A'
          }
        />
        <Line
          type="monotone"
          dataKey="score"
          stroke={chartColors.series}
          strokeWidth={2}
          dot={false}
          connectNulls
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
